import type { WorkPeriodNode } from '../types.graphql'
import type { DriverDietForm } from '@/modules/activities/components/overview/DriverDietPrompt'
import { DriverDietPrompt } from '@/modules/activities/components/overview/DriverDietPrompt'
import { usePrompt } from '@ur-solutions/react-components'
import { useDietDayMutations } from '@/modules/activities/mutations.hooks'
import { useModuleConfig } from '@/utils/hooks'
import { Module, ModuleOptionsValue } from '@/modules/companies'
import { useTranslate } from '@ur-solutions/react-hooks'
import { TextAndAction } from './TextAndAction'

const PartOfDayMapping: Record<number, string> = {
  1: '1',
  0.666666: '2/3',
  0.333333: '1/3',
}

export const DietButton: React.FC<{
  workPeriod: Pick<WorkPeriodNode, 'id' | 'driverDiet'>
  userId: string
  canEdit?: boolean
  border?: boolean
  restrictWidth?: boolean
  onChange?: () => void
}> = ({ workPeriod, userId, canEdit, border, restrictWidth, onChange }) => {
  const translations = useTranslate({
    diet: 'common.diet',
  })
  const addPrompt = usePrompt()
  const dietMutations = useDietDayMutations()
  const { getModuleOptionStatus } = useModuleConfig(Module.ACTIVITIES)
  const simpleDietViewActive = getModuleOptionStatus(
    ModuleOptionsValue.ACTIVITIES_SIMPLE_DIET_OPTION
  )
  const commentMandatory = getModuleOptionStatus(
    ModuleOptionsValue.ACTIVITIES_DIET_COMMENT_MANDATORY
  )

  async function handleAddDriverDiet() {
    const { data } = await addPrompt<DriverDietForm | null>(resolve => (
      <DriverDietPrompt
        initialData={{
          userId: userId,
          salaryCodeId: workPeriod?.driverDiet?.salaryCode?.id ?? null,
          partOfDay: workPeriod?.driverDiet?.partOfDay ?? 1,
          comment: workPeriod?.driverDiet?.comment ?? '',
        }}
        simpleView={simpleDietViewActive}
        commentMandatory={commentMandatory}
        edit={!!workPeriod?.driverDiet}
        onSubmit={resolve}
      />
    ))
    if (data === null) return

    void dietMutations
      .updateOrCreateDriverDiet({
        variables: {
          input: {
            ...data,
            workPeriod: workPeriod.id,
          },
        },
      })
      .then(() => onChange?.())
  }
  return (
    <TextAndAction
      text={translations.diet}
      actionText={
        workPeriod.driverDiet
          ? PartOfDayMapping[workPeriod.driverDiet.partOfDay ?? 0] +
            ` ${workPeriod.driverDiet.salaryCode?.name ?? ''}`
          : undefined
      }
      border={border}
      onClick={canEdit ? handleAddDriverDiet : () => {}}
      restrictWidth={restrictWidth}
    />
  )
}
